import * as React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import { CommonStore } from "common/CommonStore";
import { withStyles, CircularProgress } from "@material-ui/core";
import { Search, AddCircle as Remove } from "@material-ui/icons";

const WAIT_INTERVAL = 1500;
const ENTER_KEY = 13;

const styles = (theme) => ({
  iconSearch: {
    color: "#777777",
    left: 8,
    top: 4,
  },
  iconRemove: {
    color: "#bababa",
    right: 8,
    top: 6,
    transform: "rotate(45deg)",
    fontSize: "21px",
    cursor: "pointer",
    pointerEvents: "none" as any,
    transition: "opacity 300ms ease-in",
    opacity: 0,
  },
  iconLoad: {
    color: "#bababa",
    right: 8,
    top: 6,
  },
  inputSearch: {
    transition: "all 0.3s ease-in",
    width: "100%",
    outlineColor: theme.palette.primary.light,
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: "14px",
    padding: "7px 30px 7px 40px",
    color: "#212121",
    border: "1px solid #cccccc",
    borderRadius: "2px",
    "&:valid ~ #remove": {
      opacity: 1,
      pointerEvents: "auto" as any,
    },
    "&:hover": {
      border: "1px solid #ABC200",
    },
  },
});

export type IInputSearchProps = {
  classes: any;
  newClasses?: {
    label?: string;
    iconSearch?: string;
    inputSearch?: string;
    iconRemove?: string;
  };
  handleChange: any;
  handleClean?: Function;
  placeholder?: string;
  disabled: boolean;
};

@observer
class InputSearch extends React.Component<IInputSearchProps> {
  state = {
    value: "",
  };
  timer: any = null;

  triggerChange = () => {
    this.props.handleChange(this.state.value);
  };

  handleKeyDown = (e) => {
    if (e.keyCode === ENTER_KEY) {
      clearTimeout(this.timer);
      this.triggerChange();
    }
  };

  handleChange = (e) => {
    clearTimeout(this.timer);
    this.setState({ value: e.target.value });
    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
  };

  handleClean = () => {
    if (this.refs.inputSearch) (this.refs.inputSearch as any).value = "";
    if (this.props.handleClean) this.props.handleClean();
  };

  render() {
    const { classes, handleClean, placeholder, newClasses, disabled } =
      this.props;

    let {
      label = "",
      iconSearch = "",
      inputSearch = "",
      iconRemove = "",
    } = newClasses ? newClasses : {};

    return (
      <label
        style={{ position: "relative", float: "right" }}
        className={classNames(classes.label, { [label]: !!label })}
      >
        <Search
          style={{ position: "absolute" }}
          className={classNames(classes.iconSearch, {
            [iconSearch]: !!iconSearch,
          })}
        />
        <input
          type="text"
          ref="inputSearch"
          disabled={disabled}
          className={classNames(classes.inputSearch, {
            [inputSearch]: !!inputSearch,
          })}
          placeholder={placeholder}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          required
        />
        {CommonStore.loadingInputSearch ? (
          <CircularProgress
            size={16}
            style={{ position: "absolute" }}
            className={classNames(classes.iconLoad)}
            variant="indeterminate"
          />
        ) : (
          handleClean && (
            <Remove
              id="remove"
              style={{ position: "absolute" }}
              className={classNames(classes.iconRemove, {
                [iconRemove]: !!iconRemove,
              })}
              onClick={this.handleClean}
            />
          )
        )}
      </label>
    );
  }
}

export default withStyles(styles)(InputSearch);



// WEBPACK FOOTER //
// ./src/common/components/fields/InputSearch.tsx